<uni-label [required]="true">
    {{'ci.common.numberOfDays' | translate}}
</uni-label>
<input
    type="number"
    [(ngModel)]="value"
    (ngModelChange)="onInputChange($event)"
    uniInput
    [placeholder]="'ci.common.numberOfDays' | translate"
/>